import { Component, effect, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogComponent } from '@components/atoms';
import { ButtonLibComponent } from '@components/atoms';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-ui-modal',
  standalone: true,
  imports: [CommonModule, DialogComponent, ButtonLibComponent],
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent {
  open = input.required<boolean>();
  align = input<'left' | 'center' | 'right'>('center');
  alignContent = input<'left' | 'center' | 'right'>('center');
  rightButton = input('OK');
  leftButton = input<string | null>();
  changeState = output<boolean>();
  opened = false;
  hideButtons = input<boolean>(false);
  padding = input<string>("");

  constructor() {
    effect(() => {
      this.opened = this.open();
    });
  }
}
